import React, { PureComponent } from 'react'
import { FormCheck, Collapse, Alert } from 'react-bootstrap'
import { formatTimeString } from '../../../utils/formatters'
import './styles.css'
// This file is for the Minerva AML Sources
class AMLSourceListItem extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      allChecked: false,
      sourceTypes: [],
    }
  }
  componentDidMount() {
    const { props } = this
    const { sourceTypes } = props
    this.setState({ sourceTypes })
  }

  collapseSection = () =>
    this.setState({
      open: !this.state.open,
    })

  confirm = (event) => {
    this.setState({
      allChecked: event.target.checked,
    })
    this.props.confirm(event)
  }

  sendLink = () => window.open(this.props.shareURL, '_blank')

  render() {
    const { props, state } = this
    const { hit } = props
    const score = hit.score ? (hit.score * 100).toFixed(2) + '%' : 'N/A'
    const chevronClass = state.open ? 'fa fa-chevron-down' : 'fa fa-chevron-right'
    const sourceTypes = state.sourceTypes ? state.sourceTypes : []
    const countries = [...new Set(hit.aml_sources.map((i) => i.country).filter(Boolean))].join(', ')

    return (
      <tr className={'data-listing-item'}>
        <td>
          <div className={'data-listing-item-header'}>
            <div onClick={this.collapseSection} className={'data-listing-item-header-label'}>
              {hit.name}
              <i style={{ paddingLeft: 10, width: '10px' }} className={chevronClass} />
            </div>
          </div>
          <Collapse in={state.open}>
            <div style={{ paddingTop: 5 }}>
              <Alert variant={'secondary'} className='section-shadow data-listing-item-section' size={'lg'}>
                <div style={{ paddingTop: 5, maxWidth: 215 }}>
                  <div className={'data-listing-item-section-item'}>
                    <i className='fa fa-info-circle' style={{ color: '#1ab394' }} />
                    <div style={{ fontWeight: 'bold', minHeight: 30 }}>Relevance: {score} </div>
                  </div>
                </div>
                <div className='section-shadow data-listing-item-data'>
                  Listing Data:
                  <ul>
                    {hit.aml_sources
                      .filter((h) => sourceTypes.includes(h.source_type))
                      .map((h, i) => {
                        // Filter aml_hit_info items where source matches h.name
                        const matchedInfo = hit.aml_hit_info.filter((info) => info.source === h.name)
                        return (
                          <li key={i}>
                            {h.name} - {h.source_type} {/* Render matching aml_hit_info details if they exist */}
                            {matchedInfo.map((info, index) => (
                              <div key={index}>
                                {info.occupation && (
                                  <div>
                                    <strong>Occupation:</strong> {info.occupation}
                                  </div>
                                )}
                                {info.nationality && (
                                  <div>
                                    <strong>Nationality:</strong> {info.nationality}
                                  </div>
                                )}
                                {info.organization && (
                                  <div>
                                    <strong>Organization:</strong> {info.organization}
                                  </div>
                                )}
                              </div>
                            ))}
                            {h.listing_started ? (
                              <div>(Added to list On: {formatTimeString(h.listing_started)})</div>
                            ) : (
                              ''
                            )}
                            {h.listing_ended ? (
                              <div>(Removed from list On: {formatTimeString(h.listing_ended)})</div>
                            ) : (
                              ''
                            )}
                            {h.source_urls && h.source_urls.length > 0 ? (
                              <ul>
                                {h.source_urls.map((url, index) => (
                                  <li key={index}>
                                    <a target={'_blank'} href={url.url} rel='noreferrer'>
                                      {url.title}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            ) : (
                              ''
                            )}
                          </li>
                        )
                      })}
                  </ul>
                  {countries && <div>Countries: {countries}</div>}
                </div>
              </Alert>
            </div>
          </Collapse>
        </td>
        <td style={{ width: '10%' }}>
          <FormCheck
            defaultChecked={props.checked}
            value={this.state.allChecked}
            onClick={this.confirm}
            onChange={this.handleChange}
          />
        </td>
      </tr>
    )
  }
}

export default AMLSourceListItem
